import React, { createContext, useContext, useState, useEffect } from "react";
import { setStorageVariable } from "../utils/storage";
import { STORAGE_ENCRYPTED_DATA, STORAGE_IV } from "../constants";

interface EncryptedDataContextValue {
  encryptedData: string | null;
  iv: string | null;
  setEncryptedData: (data: string, iv: string, page: string) => void;
}

const EncryptedDataContext = createContext<EncryptedDataContextValue | undefined>(undefined);

export const EncryptedDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [encryptedData, setEncrypted] = useState<string | null>(null);
  const [iv, setIv] = useState<string | null>(null);

  // Load encrypted data and IV from local storage when the app initializes
  // MAYBE I DO NOT HAVE TO USE THIS useEffect
  useEffect(() => {
    const storedEncryptedData = localStorage.getItem("encryptedData");
    const storedIv = localStorage.getItem("iv");

    if (storedEncryptedData && storedIv) {
      setEncrypted(storedEncryptedData);
      setIv(storedIv);
    }
  }, []);

  const setEncryptedData = (data: string, iv: string, page: string) => {
    setEncrypted(data);
    setIv(iv);

    // Save encrypted data and IV to local storage
    setStorageVariable(`${page}${STORAGE_ENCRYPTED_DATA}`, data);
    setStorageVariable(`${page}${STORAGE_IV}`, iv);
  };

  return (
    <EncryptedDataContext.Provider value={{ encryptedData, iv, setEncryptedData }}>
      {children}
    </EncryptedDataContext.Provider>
  );
};

export const useEncryptedData = () => {
  const context = useContext(EncryptedDataContext);
  if (!context) {
    throw new Error("useEncryptedData must be used within an EncryptedDataProvider");
  }
  return context;
};
